module.exports = __webpack_public_path__ + "media/images/img-travel-7-13ab1545.jpg";